export const LOG_OUT_CTA = {
  MALE: `התנתק`,
  FEMALE: `התנתקי`,
};

export const LAST_LOGIN_TEXT = `כניסתך האחרונה:`
